import React, { useEffect } from "react";
import { MsalProvider, useIsAuthenticated, useMsal } from "@azure/msal-react";
import { InteractionStatus } from "@azure/msal-browser";
import { msalInstance, loginRequest } from "./msalConfig";

interface AuthGuardProps {
  children: React.ReactNode;
}

function AuthGuard({ children }: AuthGuardProps) {
  const isAuthenticated = useIsAuthenticated();
  const { inProgress } = useMsal();

  useEffect(() => {
    // Automatically redirect to Microsoft login when not authenticated
    // and no interaction is already in progress (e.g. handling redirect callback)
    if (!isAuthenticated && inProgress === InteractionStatus.None) {
      msalInstance.loginRedirect(loginRequest);
    }
  }, [isAuthenticated, inProgress]);

  // Render nothing while redirecting or during the callback
  if (!isAuthenticated) {
    return null;
  }

  return <>{children}</>;
}

interface AuthProviderProps {
  children: React.ReactNode;
}

export function AuthProvider({ children }: AuthProviderProps) {
  return (
    <MsalProvider instance={msalInstance}>
      <AuthGuard>{children}</AuthGuard>
    </MsalProvider>
  );
}
